"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFONE_STARTER_BONUS = exports.SUBMISSIONS_PAUSED_NOTE_MAX = exports.NFONE_SUPPORT_EMAIL = void 0;
/**
 * The NewForm One creator-support mailbox. Reply-to on every creator-facing
 * email, and the address shown wherever the portal or /join tells a creator
 * how to reach us. It is a Google Workspace mailbox forwarded into Plain, so
 * an emailed question lands in the same queue as a portal chat.
 *
 * On newform.ai, not newform.com: Plain only accepts alternate addresses on
 * the same domain as the workspace's main support address (support@newform.ai).
 *
 * Outbound mail still goes *from* the Resend sending domain (see
 * `emailSendingDomain`); this address is only ever a reply-to or a link.
 */
exports.NFONE_SUPPORT_EMAIL = "nfone@newform.ai";
/**
 * The longest note staff can leave creators while a program's submissions are
 * paused ("Back on Monday"). The staff setting caps the field with it and the
 * settings write refuses anything longer.
 */
exports.SUBMISSIONS_PAUSED_NOTE_MAX = 300;
/**
 * The new-creator bonus promised on /join: approve this many videos within
 * this many days of joining NewForm One and earn the amount. The apply-page
 * copy (`apps/frontend/i18n/creator/messages/{en,es}/apply.json`) and the iOS
 * application screens state the same numbers in prose; change them together.
 */
exports.NFONE_STARTER_BONUS = {
    usd: 250,
    approvedVideos: 3,
    windowDays: 10,
};
